import React from 'react';
import Auth from '../../../../Auth';
import Sales from './Sales';
import Toplist from './Toplist';
import CountryToplist from './CountryToplist';

class Home extends React.Component {
	render() {
		return (
			<div>
				<div style={{ textAlign: 'center', marginTop: '20px' }}>
					Tillsammans har vi sålt: <span style={{ fontWeight: 'bold' }}>{ this.props.group_sold_shares }/{ this.props.settings.shares } andelar</span>
				</div>

				<Sales
					parent={ this.props.parent }
					remaining_shares={ this.props.remaining_shares }
					remaining_days={ this.props.remaining_days }
					settings={ this.props.settings }
					sold_shares={ this.props.sold_shares }
				/>

				{ (this.props.toplist && this.props.toplist.length > 0) &&
					<Toplist items={ this.props.toplist } />
				}

				{ (this.props.country_toplist && this.props.country_toplist.length > 0) &&
					<CountryToplist items={ this.props.country_toplist } />
				}

				<div style={{ float: 'left', width: '100%', marginTop: '20px', textAlign: 'center' }}>
					<div style={{ marginBottom: '10px' }}>
						<div
							onClick={ () => this.props.parent.setState({ page: 'how-to' }) }
							style={{
								padding: '10px',
								textAlign: 'center',
								cursor: 'pointer'
							}}
						>
							<span style={{ fontWeight: 'normal' }}>Hur fungerar det?</span> <strong>Läs mer</strong>
						</div>
					</div>

					<div onClick={ () => Auth.logout() } className="button pink2-invert auto-width">Logga ut</div>
				</div>
			</div>
		)
	}
}
export default Home;



// WEBPACK FOOTER //
// ./src/components/user/Dashboard/Home/index.js